import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "d-row-3" }
const _hoisted_3 = { class: "d-checkbox" }

import { parseError } from "@/common/util";
import { useReportStore } from "@/stores/report";
import { showToastError } from "@/toastification";
import { computed, reactive } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SapReportView',
  setup(__props) {

const state = reactive({
    //LUIS ANGEL
    weeklyOptions: { weekly: false },
    dateMonth: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
    showLoading: false
});

const reportStore = useReportStore();
// Mi prueba de codigo
const weeklyReportText = computed(() => {
    let result = ""
    if (state.weeklyOptions.weekly) {
        result = "with weekly "
    }
    return result
})
// Aqui termina mi codigo


//Mi funcion prueba
async function getWeeklyReport() {
    state.showLoading = true;
    try {
        await reportStore.downloadSap(state.dateMonth.year, state.dateMonth.month + 1, state.weeklyOptions.weekly)
    }

    catch (e) {
        console.error(e);
        showToastError("Report was unable to generate: " + parseError(e));
    }
    finally {
        state.showLoading = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", null, "Get SAP report for selected month " + _toDisplayString(weeklyReportText.value), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("label", null, "Monthly", -1)),
        _createVNode(_component_VueDatePicker, {
          modelValue: state.dateMonth,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.dateMonth) = $event)),
          "month-picker": "",
          clearable: false
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { for: "weekly" }, "Weekly", -1)),
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          name: "weekly1",
          id: "weekly1",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.weeklyOptions.weekly) = $event))
        }, null, 512), [
          [_vModelCheckbox, state.weeklyOptions.weekly]
        ])
      ]),
      _createElementVNode("div", { class: "buttons" }, [
        _createElementVNode("button", {
          class: "accent",
          onClick: getWeeklyReport
        }, "Get report")
      ])
    ])
  ]))
}
}

})